/** @format */

import { useState, useEffect } from 'react'
import useGlobalData from './useGlobalData'
import { GlobalDataKey } from 'src/store/globalDataSlice'
import { LabelValueItem } from 'src/utils/interface'
import Cookie from 'js-cookie'
import { _$ } from '@king-design/react'

const lang = Cookie.get('ksc_lang')

const typeObject = {
  monitorRegionList: {
    label: 'regionName',
    value: 'regionKey',
    allValue: ''
  },
  productList: {
    label: 'productName',
    value: 'productType',
    allValue: 999
  }
}

const useTableGroup = (type: GlobalDataKey, hidePod?) => {
  const gloabalList = useGlobalData(type)
  const [groupData, setGroupData] = useState<LabelValueItem[]>([])
  useEffect(() => {
    if (gloabalList?.length) {
      const groupData = gloabalList.map(item => {
        const label =
          type === 'monitorRegionList' && lang === 'en'
            ? item[typeObject[type]?.value]
            : item[typeObject[type]?.label]
        // 容器引擎-Pod productType手动转成45
        const value =
          hidePod && item[typeObject[type]?.value] === 29 ? 45 : item[typeObject[type]?.value]
        return {
          label: label || '',
          value: value !== undefined ? value : ''
        }
      })
      setGroupData([{ label: _$('全部'), value: typeObject[type]?.allValue || '' }, ...groupData])
    }
  }, [gloabalList])
  return groupData
}

export default useTableGroup
